// removed by extract-text-webpack-plugin
module.exports = {"container":"PricingRow__container__38boa","header":"PricingRow__header__18sW8","content":"PricingRow__content__1Lq_u","table":"PricingRow__table__1NRHe","image-circle":"PricingRow__image-circle__kbXMl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Quoting/Board/Pricing/PricingRow/PricingRow.scss
// module id = 238
// module chunks = 0